import { useEffect, useState } from 'react';
import { products as fallback } from '../mock';
import { api } from '../lib/api';

// Produtos do site vêm do banco (editados em Admin → Produtos). A lista de mock.js só aparece
// enquanto carrega ou se a API falhar. A busca começa assim que o módulo é importado.
const adapt = (p) => ({
  id: p.id, name: p.name, subtitle: p.subtitle || '', tag: p.tag || '', description: p.description || '',
  oldPrice: p.old_price || 0, price: p.price, image: p.image, freeShipping: p.free_shipping !== false, promo: p.promo || null,
});

let loaded = null;
const request = api.get('/products')
  .then(({ data }) => { if (Array.isArray(data) && data.length) loaded = data.map(adapt); })
  .catch(() => {});

export default function useProducts() {
  // globalThis.__PP_PRODUCTS__: lista embutida no HTML pelo build (a primeira tela já nasce com os preços certos)
  const [list, setList] = useState(loaded || globalThis.__PP_PRODUCTS__ || fallback);
  useEffect(() => {
    let off = false;
    request.then(() => { if (!off && loaded) setList(loaded); });
    return () => { off = true; };
  }, []);
  return list;
}
